import './AdminConsultas.scss'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { Button, Spin, Table, Select, Row, Col, Modal, Progress, Icon, notification } from 'antd'
import { getMesesPromise, getConsultasPromise, exportConsultasPromise } from './promises'
import { ReportService, UploadProgressService } from '../../services'

class AdminConsultas extends Component {
  state = {
    isLoading: true,
    consultas: [],
    mes: null,
    meses: [],

    stage: 1,
    exporting: false,
    exportProgress: 0,
    exportError: null,
    isLoadingReport: false,
    exportCanceled: false
  }

  componentWillUnmount() {
    if (this.progressService) {
      try { this.progressService.close() } catch (e) {}
      this.progressService = null
    }
  }

  async componentDidMount() {
    const meses = await getMesesPromise()
    await this.setState({ meses, isLoading: false })
  }

  renderTableColumns() {
    const { t } = this.props

    const columns = [
      { title: t('messages.aml.subclient'), dataIndex: 'subcliente' },
      { title: t('messages.aml.type'), dataIndex: 'tipo' },
      { title: t('messages.aml.basePrice'), dataIndex: 'base', align: 'right' },
      { title: t('messages.aml.rateRange'), dataIndex: 'tarifa' },
      { title: t('messages.aml.unitRate'), dataIndex: 'tarifaUnit', align: 'right' },

      {
        title: t('messages.aml.records'),
        dataIndex: 'registros',
        align: 'right',
        render: (text) => {
          return this.numberFormatD(text,"")
        }
      },
      {
        title: t('messages.aml.admin.query'),
        dataIndex: 'consultas',
        align: 'right',
        render: (text) => {
          return this.numberFormatD(text,"")
        }
      },
      {
        title: t('messages.aml.maxUsers'),
        dataIndex: 'totUsuarios'
      },
      {
        title: t('messages.aml.value'),
        dataIndex: 'valor',
        align: 'right',
        render: (text) => {
          return this.numberFormatD(text,"")
        }
      }
    ]

    return columns
  }

  numberFormat ( data, symbol ) {
    return this.numberFormatD(data, symbol, 2);
  }

  numberFormatD ( data, symbol, decimals ) {
    if(data == null || data == "" || isNaN(data)) {
      return data;
    }else {
      var int = Math.floor(data);
      var decimal = data - int;
      var s=(int+""), a=s.split(""), out="", iLen=s.length;
      for ( var i=0 ; i<iLen ; i++ ) {
        if ( i%3 === 0 && i !== 0 ) {
          out = '.'+out;
        }
        out = a[iLen-i-1]+out;
      }
      let pos = decimal.toString().indexOf(".");
      return symbol+" "+out+(decimal>0?","+decimal.toString().substring(pos+1, pos+1+decimals):"");
    }
  }

  async changeMes(mes) {
    this.setState({ mes, isLoading: true })
    let consultas =  await getConsultasPromise(mes)

    let base = 0
    let registros = 0
    let _consultas = 0
    let exitosas = 0
    let usuariosUnicos
    let maxUsuarios
    let valor = 0

    for(let i=0;i<consultas.length;i++) {
      let row = consultas[i]
      if(row.subcliente === 'SubTotal') {
        base += row.base
        registros += row.registros
        _consultas += row.consultas
        exitosas += row.exitosas
        valor += row.valor

        usuariosUnicos = row.usuariosUnicos
        maxUsuarios = row.maxUsuarios
      }
    }

    let totUsuarios = usuariosUnicos
    let totmax_usuarios = 0
    if(maxUsuarios > -1) {
      totmax_usuarios=(usuariosUnicos-maxUsuarios)*0.5
      if(totmax_usuarios<0) {
        totmax_usuarios = 0;
      }
      totUsuarios = usuariosUnicos + "/" + maxUsuarios + "=" + totmax_usuarios
    }

    let total = { total: true, subcliente:'Total', base, registros, consultas: _consultas, exitosas, totUsuarios, valor: valor + totmax_usuarios }
    consultas.push(total)

    this.setState({ consultas, isLoading: false })
  }

    cancelExportEvent = () => {
        this.setState({ exportCanceled: true })

        if (this.progressService) {
            try { this.progressService.close() } catch (e) {}
            this.progressService = null
        }

        this.setState({
            exporting: false,
            exportProgress: 0,
            exportError: null,
            isLoadingReport: false
        })
    }

    cancelExportEvent = () => {
        this.setState({ exportCanceled: true })

        if (this.progressService) {
            try { this.progressService.close() } catch (e) {}
            this.progressService = null
        }

        this.setState({
            exporting: false,
            exportProgress: 0,
            exportError: null,
            isLoadingReport: false
        })
    }

    async exportConsultas() {
        const { t } = this.props
        const { mes } = this.state

        if (this.progressService) {
            try { this.progressService.close() } catch (e) {}
            this.progressService = null
        }

        await this.setState({
            exporting: true,
            exportProgress: 0,
            exportError: null,
            stage: 1,
            isLoadingReport: true,
            exportCanceled: false
        })

        try {
            const response = await exportConsultasPromise({ mes })

            if (response && response.batchId) {
                this.listenExportProgress(response.batchId, mes)
            } else {
                throw new Error(t('messages.aml.exportMissingBatchId'))
            }
        } catch (e) {
            console.error(t('messages.aml.exportStartError'))
            this.setState({
                exportError: t('messages.aml.exportStartError'),
                isLoadingReport: false
            })
        }
    }

    listenExportProgress(batchId, mes) {
        const { t } = this.props
        this.progressService = UploadProgressService.listenProgress(
            batchId,
            {
                onProgress: (progressData) => {
                    if (this.state.exportCanceled) return

                    const value = progressData.progress
                    const lastProgress = this.state.exportProgress
                    const stage = progressData.stage

                    if(stage == 2){
                        this.setState({stage: 2});
                    }
                    if (value > lastProgress) {
                        this.setState({ exportProgress: value, exportError: null })
                    }
                },
                onComplete: async (data) => {
                    if (this.state.exportCanceled) return;
                    this.setState({ exportProgress: 100 })
                    const builtPath = `reportes/${data.folder}/${batchId}.xlsx`
                    const fileName = `consultas_${mes}.xlsx`

                    try {
                        await ReportService.read('/inputFile', {
                            path: builtPath,
                            remove: true
                        }, null, fileName, null, t)

                        notification.success({
                            message: t('messages.aml.successfulOperation'),
                            description: t('messages.aml.successDownload')
                        })
                    } catch (err) {
                        notification.error({ message: t('messages.aml.error.download') })
                    } finally {
                        this.setState({
                            exporting: false,
                            exportProgress: 0,
                            downloadingStage: false,
                            isLoadingReport: false
                        })
                    }
                },
                onInactivity: () => {
                    if (this.state.exportCanceled) return
                    notification.warning({
                        message: t('messages.aml.warning'),
                        description: t('messages.aml.downloadInactivity')
                    })
                },
                onError: (error) => {
                    if (this.state.exportCanceled) return
                    this.setState({
                        exportError: t(error) || t('messages.aml.connectionError'),
                        exporting: false
                    })
                }
            }
        )
    }

  render() {
    const { t } = this.props
    const { isLoading, meses, mes, consultas,
        exporting, exportProgress, exportError, stage} = this.state

    return (
      <div className="admin-consultas">
        <div className="tools-area">
          <Row type="flex" align="middle">
            <Col>
              <Select onChange={ (mes) => this.changeMes(mes) } placeholder={t('messages.aml.selectMonth')} style={{width: '150px'}}>
              {meses.map(mes =>
                <Select.Option value={ mes }>{mes.substring(0,4) + '-' + mes.substring(4)}</Select.Option>
              )}
              </Select>
            </Col>
            <Col className="consultas-update-note-col">
              <p className="consultas-update-note">{t('messages.aml.admin.queryUpdateNote')}</p>
            </Col>
            <Col>
              {mes &&
                <Button
                  type="primary"
                  onClick={this.exportConsultas.bind(this)}
                  disabled={exporting}
                  icon="file-excel">
                  {t('messages.aml.export')}
                </Button>
              }
            </Col>
          </Row>
        </div>
        <div className="table-wrapper">
          { isLoading ?
              <Spin spinning="true" size="large" />
              :
              <Table dataSource={ consultas } columns={ this.renderTableColumns() } size="small" pagination={false} rowClassName={(record, index) => { if(record.total === true) return 'total-row'; else if(record.subcliente === 'SubTotal') return 'subtotal-row'}}
              />
          }
        </div>

          <Modal
              visible={exporting}
              closable={!!exportError}
              maskClosable={false}
              footer={
                  exportError ? [
                      <Button key="close" onClick={() => this.setState({ exporting: false, exportError: null })}>
                          {t('messages.aml.btnClose')}
                      </Button>
                  ] : [
                      <Button key="cancel" onClick={this.cancelExportEvent}>
                          {t('messages.aml.cancel')}
                      </Button>
                  ]
              }
          >
              {exportError ? (
                  <div style={{ color: '#f5222d', textAlign: 'center' }}>
                      <Icon type="close-circle" style={{ fontSize: 24, marginBottom: 10 }} />
                      <p>{exportError}</p>
                  </div>
              ) : (
                  <div style={{ textAlign: 'left' }}>
                      <p>
                          {stage === 1 ? t('messages.aml.extractingData')
                              : t('messages.aml.generatingReport')}
                      </p>
                      <Progress percent={Math.round(exportProgress)} />
                  </div>
              )}
          </Modal>
      </div>
    )
  }
}

export default withTranslation()(AdminConsultas)
